import { DetailText } from "../../components/units/Text"
import { Title, Text } from "../../components/units/Text"
import { BoxWrapper } from "../../components/Wrappers/Wrappers"
import { LgFormInput } from "../../components/Form/FormInput"
import { RestApiState } from "../../interfaces/Rest/types"
import { createAccumulator } from "../../components/Rest/accumulator/components/createAccumulator"
import { CreateAccumulatorResponse } from "../../interfaces/Accumulator/types"
import { FlexWrapper } from "../../components/Wrappers/Wrappers"

import { useState } from "react"
import { useEffect } from "react"

function submitClassHandler(status: RestApiState): string {
    // Defines css class based on status
    if (status === RestApiState.Success) {
        return "submit-btn-success"
    }

    if (status !== RestApiState.Idle)  {
        return 'submit-btn disabled'
    }

    return "bg-secondary text-light"
}

const AcbCreateMockView = () => {
    const [requestState, setRequestState] = useState<RestApiState>(RestApiState.Idle)
    const [serialNumber, setSerialNumber] = useState<string>("")
    const [responseData, setResponseData] = useState<CreateAccumulatorResponse | undefined>(undefined)

    const statusText = ():string => {
        let text = ''
        switch(requestState) {
            case RestApiState.Idle : text = "" ; break;
            case RestApiState.Pending : text = "Обновляется"; break;
            case RestApiState.Success : text = "Обновлено"; break;
            case RestApiState.BadRequest : text = "Заполните поля"; break;
            case RestApiState.ServerError : text = "Ошибка сервера"; break;
            case RestApiState.Unknown : text = "Неизвестная ошибка"; break;
            default : text = "..."; break;
        }
        return text
    }

    const handelSubmit = async (e: any) => {
        e.preventDefault();
        setRequestState(RestApiState.Pending)
        createAccumulator({serial_number: serialNumber})
            .then((response) => {
                if (response.status === 201) {
                    setRequestState(RestApiState.Success)
                    setResponseData(response.data)
                } else {
                    setRequestState(RestApiState.Unknown)
                }
            })
            .catch((error) => {
                console.error('Error creating accumulator:', error);
                if (error.response && error.response.status === 400) {
                    setRequestState(RestApiState.BadRequest)
                    setResponseData(error.response.data)
                } else if (error.response && error.response.status === 500) {
                    setRequestState(RestApiState.ServerError)
                } else {
                    setRequestState(RestApiState.Unknown)
                }
            });
    }

    return (
        <div className='content-wrapper flex-grow acb-dashboard-wrapper show-up'>
            <DetailText href={`/react/acblist`}>
                    Назад
            </DetailText>
            <br />
            <br />
            <Title className="dispaly-block">Создать архивную АКБ</Title>
            <br />
            <BoxWrapper bg="bg-primary" p="p3" r="r15">
                <Text size="lg" className="bold dispaly-block">Форма ввода АКБ</Text>
                <br />
                <form onSubmit={handelSubmit} className="organization-form">
                    <div className="flex flex-column">
                        <LgFormInput 
                            value={serialNumber} 
                            label='Серийный номер АКБ' 
                            name='serial_number' 
                            type='text' 
                            required={true} 
                            valueSetter={(e: React.ChangeEvent<HTMLInputElement>) => {
                                const { name, value } = e.target;
                                setSerialNumber(value)
                            }} 
                            disabled={ requestState !== RestApiState.Idle }
                            maxLength={7}
                        />
                    </div>
                    <br />
                    <div className="flex flex-column">
                        <button 
                            type="submit"
                            disabled={ requestState !== RestApiState.Idle }
                            className={`${submitClassHandler(requestState)} p2 bold pointer scale-down-on-click` }
                            style={{position:'relative', width: '100%', borderRadius: '5px', outline:'none', border: 'none'}}
                            >
                            { requestState === RestApiState.Idle && <Text  className="slide-bottom-to-top">Сохранить</Text>  }
                            { requestState === RestApiState.Pending && <Text className="slide-bottom-to-top">{ <div className="btnloader"></div> }</Text>}
                            { (requestState !== RestApiState.Pending && requestState !== RestApiState.Idle) && <Text className="slide-bottom-to-top">{ statusText() }</Text>} 
                        </button>
                    </div>
                    
                </form>
            </BoxWrapper>
            <br />
            {
                (responseData && requestState === RestApiState.Success) && (
                    <BoxWrapper bg="bg-primary" p="p3" r="r15" className="show-up">
                        <Text size="lg" className="bold dispaly-block">АКБ успешно создана</Text>
                        <br />
                        <BoxWrapper p="p2" bg="bg-gray" r="r10">
                            <Text className="dispaly-block">Ключ АКБ: {responseData.secret}</Text>
                        </BoxWrapper>
                        <br />
                        <FlexWrapper flexWrap="nowrap">
                            <DetailText 
                                href={`/react/acb/detail/${serialNumber}`} 
                                className="full-width flex justify-center align-center p2 pointer scale-down-on-click"
                                style={{
                                    border: "1px solid #ccc"
                                }}
                                r="r10"
                                color="primary"
                            >
                                Перейти к АКБ...
                            </DetailText>
                            <BoxWrapper 
                                p="p2" 
                                bg="bg-transparent" 
                                r="r10"
                                style={{border: "1px solid #ccc"}}
                                className="pointer flex align-center justify-center full-width scale-down-on-click"
                                onClick={() => {
                                        setRequestState(RestApiState.Idle)
                                        setResponseData(undefined)}
                                    }
                            >
                                <Text color="primary" 
                                    className="pointer"
                                >
                                    Создать еще
                                </Text>
                            </BoxWrapper>
                        </FlexWrapper>

                    </BoxWrapper>
                )
            }
            {
                (responseData && requestState === RestApiState.BadRequest) && (
                    <BoxWrapper bg="bg-primary" p="p3" r="r15" className="show-up">
                        <Text size="lg" className="bold dispaly-block">Ошибка при создании АКБ</Text>
                        <br />
                        <BoxWrapper p="p2" bg="bg-gray" r="r10">
                            <Text className="dispaly-block">Сообщение: Серийный номер уже существует</Text>
                        </BoxWrapper>
                        <br />
                        <BoxWrapper 
                            p="p2" 
                            bg="bg-transparent" 
                            r="r10"
                            style={{border: "1px solid #ccc"}}
                            className="pointer flex align-center justify-center"
                            onClick={() => {
                                    setRequestState(RestApiState.Idle)
                                    setResponseData(undefined)}
                                }
                        >
                            <Text color="primary" 
                                className="pointer scale-down-on-click"
                            >
                                Попробуйте еще раз
                            </Text>
                        </BoxWrapper>

                    </BoxWrapper>
                )
            }
        </div>
    )
}

export default AcbCreateMockView


    // const setCommissionData = (newData: typeof commissionProps.commission.data): void => {
    //     setProps(prev => ({
    //         ...prev,
    //         commission: {
    //           ...prev.commission,
    //           data: newData,
    //         },
    //     }));
    // }


    // const updateDataValue = (e: React.ChangeEvent<HTMLInputElement>):void => {
    //     const { name, value } = e.target;
    //     const key = name as keyof CommisionProps;
        
    //     setProps((prev) => ({
    //         ...prev,
    //         commission: {
    //           ...prev.commission,
    //           data: prev.commission.data
    //             ? { ...prev.commission.data, [key]: value }
    //             : null,
    //         },
    //     }));

    //     useEffect(() => {
    //         const fetchSectionData = async () => {
    //             fetchCommissionData(serial_number, user.role_slug, setCommissionData)
    //         }
    //         fetchSectionData()
    //     }, [])

    //     const handelSubmit = (e: any) => {
    //         e.preventDefault();
    //         updateCommissionComment(serial_number, user.role_slug, commissionProps.commission.data , updateRestApiStatus)
    //     }